import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComplaintService } from 'src/app/_service/complaint.service';
declare var $: any;
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-complaints-list',
  templateUrl: './complaints-list.component.html',
  styleUrls: ['./complaints-list.component.css']
})
export class ComplaintsListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; complaintList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circle = '';
  search: string; currentUserId: any; status = ''
  booleanValue: any = false;
  constructor(private userapi: UserService, private sharedapi: SharedService, private complaintapi: ComplaintService, public leadapi: LeadsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  ngAfterViewInit() {
    this.loadComplaintList(0, this.perpage);
  }

  async loadComplaintList(pageIndex, perpage) {
    this.complaintList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search;
    this.loading = true; this.loaded = false;
    this.complaintapi.getComplaintsList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.complaintList = data.data;
      } else {
        this.complaintList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }


  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadComplaintList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadComplaintList(event.pageIndex, event.pageSize);
  }

  //------------------Export Product List---------------------//
exportComplaintList() {
  if (this.complaintList.length > 0) {
    let data = [];
    let titles = ['TICKET NO', 'PATIENT NAME', 'PATIENT NO','CIRCLE','SURGERY DATE','COMPLAINT TIME','LEAD OWNER','TREATMENT','BD','DOCTOR','HOSPITAL INFRASTRUCTURE','HOSPITAL STAFF','ADMISSION','DISCHARGE','OTHERS','FINAL STATUS'];
   
    data.push(titles);
    for (let key in this.complaintList) {

      var bd_status = '';
      if(this.complaintList[key].bd_comp_status == 1)
      {
        bd_status = 'No Complaint';
      } else if(this.complaintList[key].bd_comp_status == 2)
      {
        bd_status = 'Complete';
      } else if(this.complaintList[key].bd_comp_status == 3)
      {
        bd_status = 'Complaint';
      }

      var doctor_status = '';
      if(this.complaintList[key].doctor_comp_status == 1)
      {
        doctor_status = 'No Complaint';
      } else if(this.complaintList[key].doctor_comp_status == 2)
      {
        doctor_status = 'Complete';
      } else if(this.complaintList[key].doctor_comp_status == 3)
      {
        doctor_status = 'Complaint';
      }

      var hospital_infrastructure_status = '';
      if(this.complaintList[key].hospital_infrastructure_comp_status == 1)
      {
        hospital_infrastructure_status = 'No Complaint';
      } else if(this.complaintList[key].hospital_infrastructure_comp_status == 2)
      {
        hospital_infrastructure_status = 'Complete';
      } else if(this.complaintList[key].hospital_infrastructure_comp_status == 3)
      {
        hospital_infrastructure_status = 'Complaint';
      }

      var hospital_staff_status = '';
      if(this.complaintList[key].hospital_staff_comp_status == 1)
      {
        hospital_staff_status = 'No Complaint';
      } else if(this.complaintList[key].hospital_staff_comp_status == 2)
      {
        hospital_staff_status = 'Complete';
      } else if(this.complaintList[key].hospital_staff_comp_status == 3)
      {
        hospital_staff_status = 'Complaint';
      }

      var admission_status = '';
      if(this.complaintList[key].admission_comp_status == 1)
      {
        admission_status = 'No Complaint';
      } else if(this.complaintList[key].admission_comp_status == 2)
      {
        admission_status = 'Complete';
      } else if(this.complaintList[key].admission_comp_status == 3)
      {
        admission_status = 'Complaint';
      }

      var discharge_status = '';
      if(this.complaintList[key].discharge_comp_status == 1)
      {
        discharge_status = 'No Complaint';
      } else if(this.complaintList[key].discharge_comp_status == 2)
      {
        discharge_status = 'Complete';
      } else if(this.complaintList[key].discharge_comp_status == 3)
      {
        discharge_status = 'Complaint';
      }

      var others_status = '';
      if(this.complaintList[key].others_comp_status == 1)
      {
        others_status = 'No Complaint';
      } else if(this.complaintList[key].others_comp_status == 2)
      {
        others_status = 'Complete';
      } else if(this.complaintList[key].others_comp_status == 3)
      {
        others_status = 'Complaint';
      }

      var final_status = '';
      if(this.complaintList[key].final_status == 1)
      {
        final_status = 'Pending';
      } else if(this.complaintList[key].final_status == 2)
      {
        final_status = 'Complete';
      } 

      var surgery_date =''; 
      if(this.complaintList[key].surgery_date){
        surgery_date = formatDate(this.complaintList[key].surgery_date*1000, 'dd MMM, yyyy', 'en-US');
      }
      var complaint_time =''; 
      if(this.complaintList[key].created_at){
        complaint_time = formatDate(this.complaintList[key].created_at*1000, 'dd MMM, yyyy , h:mm a', 'en-US');
      }
     
      let extData = [this.complaintList[key].ticket_id,this.complaintList[key].patient,this.complaintList[key].phone,this.complaintList[key].circle_name,surgery_date,complaint_time,this.complaintList[key].bdname,this.complaintList[key].treatmentname,bd_status,doctor_status,hospital_infrastructure_status,hospital_staff_status,admission_status,discharge_status,others_status,final_status];

      data.push(extData)
    }
    let ws = XLSX.utils.aoa_to_sheet(data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
    XLSX.writeFile(wb, 'complaintlist_' + utc + '.xlsx');
  } else {
    this.sharedapi.presentToast('No Complaint Data found!');
  }
}


}
